export enum ProfileTabsKeys {
  ACCOUNT_INFO = 'ACCOUNT_INFO',
  BILLING = 'BILLING',
  SETTINGS = 'SETTINGS',
}

export const PROFILE_DEFAULT_TAB = ProfileTabsKeys.ACCOUNT_INFO;
